module.exports = __webpack_public_path__ + "static/bimbo-canada-logo-f4cfcb67b9f130081a181473defc9c53.png";